module.exports = __webpack_public_path__ + "img/chanpin.ffccd2ee.png";